import { Component, OnInit } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SysAdminService } from "../services/sysadmin.service";

@Component({
	selector: "app-user-group-assignment",
	templateUrl: "./user-group-assignment.component.html",
	styleUrls: ["./user-group-assignment.component.css"],
})
export class UserGroupAssignmentComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private sysAdminService: SysAdminService) {}

	ngOnInit(): void {
		// this.loadSchoolist();
		this.loadPreference();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////

	subscription: any;

	SchoolID: any;
	lstSchool: any = [];

	SelectedUserGroup: any;

	AllowMultipleSchools: boolean = false;
	AllowDistrictGroups: boolean = false;

	Update: any = false;

	////////////////////////////////////

	////////////////////////////////////
	// Load Data
	////////////////////////////////////

	private loadPreference() {
		var result = this.sysAdminService.UserGroupPreferencesSelect();
		result.subscribe(
			(response: any) => {
				this.AllowMultipleSchools = response.AllowMultipleSchools;
				this.AllowDistrictGroups = response.AllowDistrictGroups;
			},
			(error) => {}
		);
	}

	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////

	////////////////////////////////////

	////////////////////////////////////
	// Events
	////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;
	}
	onGroupSelected(val) {
		this.SelectedUserGroup = val;
	}

	onAddedContainer(val) {
		this.Update = val;
	}
	////////////////////////////////////

	////////////////////////////////////
	// Helpers
	////////////////////////////////////

	IsDistrictGroup(): boolean {
		if (this.SelectedUserGroup == null) {
			return false;
		} else {
			return this.SelectedUserGroup.UserLevelID == 1;
		}
	}

	////////////////////////////////////
}
